import {
    ADD_FLIGHT_TO_MCDM_ONLY_DTO_CLAZZ_VALUE,
    ADD_FLIGHT_TO_REROUTING_DTO_CLAZZ_VALUE,
    AddFlightToMcdmOnlyDto,
    AddFlightToReroutingDto,
    AVOID_VIA_AIRSPACE_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE,
    AVOID_VIA_HOTSPOT_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE,
    AVOID_VIA_POINT_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE,
    AVOID_VIA_REGULATION_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE,
    AvoidViaAirspaceReroutingConstraintDto,
    AvoidViaHotspotReroutingConstraintDto,
    AvoidViaPointReroutingConstraintDto,
    AvoidViaRegulationReroutingConstraintDto,
    CapacityValue,
    CountType,
    DatasetDto,
    DatasetType,
    DaysOfWeekPresence,
    DELTA_LEVEL_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE,
    DeltaLevelReroutingConstraintDto,
    EHelpDeskTicketChoiceDto,
    EHelpDeskTicketDto,
    EXCLUDE_FLIGHT_IN_REGULATION_DTO_CLAZZ_VALUE,
    ExcludeFlightInRegulationDto,
    FlightDto,
    FlightResultList,
    FORCE_FLIGHT_IN_REGULATION_DTO_CLAZZ_VALUE,
    ForceFlightInRegulationDto,
    HotspotDto,
    HotspotId,
    HotspotKind,
    HotspotSeverity,
    HotspotStatus,
    LEVEL_AND_SPEED_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE,
    LevelAndSpeedReroutingConstraintDto,
    LifeCycleEventType,
    LoadClassification,
    LocationDto,
    MCDM_FLIGHT_TOPIC_CLAZZ_VALUE,
    MCDM_MEASURE_TOPIC_CLAZZ_VALUE,
    MCDM_ONLY_DTO_CLAZZ_VALUE,
    McdmApprovalState,
    McdmFlightTopic,
    McdmMeasureTopic,
    McdmOnlyDto,
    McdmOnlyFieldType,
    McdmRole,
    McdmState,
    McdmStatefulTopic,
    McdmTopic,
    McdmTopicFieldType,
    McdmTopicList,
    McdmUserRoleAndApprovalState,
    MeasureDto,
    MeasureSubType,
    MeasureType,
    Otmv,
    RegInitialConstraint,
    REGULATION_DTO_CLAZZ_VALUE,
    REGULATION_OR_MCDM_ONLY_DTO_CLAZZ_VALUE,
    REGULATION_PROPOSAL_DTO_CLAZZ_VALUE,
    RegulationCauseDto,
    RegulationDto,
    RegulationFieldType,
    RegulationLocationCategory,
    RegulationOccupancyConstraintDto,
    RegulationOrMcdmOnlyDto,
    RegulationProposalAction,
    RegulationProposalDto,
    RegulationProposalFieldType,
    RegulationProposalKind,
    RegulationReasonType,
    RegulationState,
    REINCLUDE_FLIGHT_IN_REGULATION_DTO_CLAZZ_VALUE,
    ReincludeFlightInRegulationDto,
    REMOVE_FLIGHT_FROM_MCDM_ONLY_DTO_CLAZZ_VALUE,
    REMOVE_FLIGHT_FROM_REROUTING_DTO_CLAZZ_VALUE,
    RemoveFlightFromMcdmOnlyDto,
    RemoveFlightFromReroutingDto,
    REROUTING_DTO_CLAZZ_VALUE,
    ReroutingApplyKind,
    ReroutingConstraintDto,
    ReroutingDto,
    ReroutingFieldType,
    ReroutingPurpose,
    ScenarioTvMatchingKind,
    TimePeriod,
    TRAFFIC_VOLUME_LOCATION_DTO_CLAZZ_VALUE,
    TrafficType,
    TrafficVolumeLocationDto,
    UNFORCE_FLIGHT_IN_REGULATION_DTO_CLAZZ_VALUE,
    UnforceFlightInRegulationDto,
    UpdateFlightInMeasureDto,
} from 'app/model/CORE';
import TimeUtils from './TimeUtils';
import TimePeriodUtils from './TimePeriodUtils';
import Utils from './Utils';
import AirspaceUtils from './AirspaceUtils';
import { RegulationPeriods } from 'app/model/client/CORE';
import { DisplayMeasureType, MCDMKind } from 'app/components/panels/measure/RegulationEditorPanel';
import { McdmMeasure, MonitoredMcdmMeasure, MonitoredMeasure } from 'app/model/SOL49';
import { ServiceFactory } from 'app/service/ServiceFactory';
import AppContext from 'app/common/context/AppContext';
import AuthorisationUtils from 'app/common/context/AuthorisationUtils';
import { notification } from 'antd';
import { MeasuresSettings } from 'app/components/dashboard/detailed/measures/MeasuresSettings';
import produce from 'immer';
import memoizeOne from 'memoize-one';

export default class MeasureUtils {
    static readonly ALL_REGULATION_FIELDS: RegulationFieldType[] = Object.keys(
        RegulationFieldType,
    ) as RegulationFieldType[]; // works since string enum values
    static readonly ALL_REGULATION_FIELDS_NON_RD: RegulationFieldType[] = Utils.copyAndRemoveAllIfNeeded(
        Object.keys(RegulationFieldType),
        [RegulationFieldType.SOURCE_HOTSPOT, RegulationFieldType.MCDM_REQUIRED],
    ) as RegulationFieldType[]; // works since string enum values - Removing fields that are not allowed with OPS certificate
    static readonly ALL_REGULATION_PROPOSAL_FIELDS: RegulationProposalFieldType[] = Object.keys(
        RegulationProposalFieldType,
    ) as RegulationProposalFieldType[]; // works since string enum values
    static readonly ALL_MCDM_ONLY_FIELDS: McdmOnlyFieldType[] = Object.keys(McdmOnlyFieldType) as McdmOnlyFieldType[]; // works since string enum values
    static readonly ALL_REROUTING_FIELDS: ReroutingFieldType[] = Object.keys(
        ReroutingFieldType,
    ) as ReroutingFieldType[]; // works since string enum values
    static readonly ALL_MCDM_TOPIC_FIELDS: McdmTopicFieldType[] = Object.keys(
        McdmTopicFieldType,
    ) as McdmTopicFieldType[]; // works since string enum values

    static readonly NO_DURATION_VALUE = -1;

    /**
     * The default re-routing apply kind to use in normal datasets (i.e. not in simulations).
     * Gregory advises that we use RRN.
     */
    static readonly DEFAULT_REROUTING_APPLY_KIND = ReroutingApplyKind.FOR_INDICATION_WITH_AUTOMATIC_RRN;

    static readonly NMOC_MCDM_USER_ID = 'CFMU';

    static isRegulationOrMcdmOnly(item: MeasureDto): item is RegulationOrMcdmOnlyDto {
        return (
            item.clazz === MCDM_ONLY_DTO_CLAZZ_VALUE ||
            item.clazz === REGULATION_DTO_CLAZZ_VALUE ||
            item.clazz === REGULATION_PROPOSAL_DTO_CLAZZ_VALUE
        );
    }

    static isMcdmOnly(item: MeasureDto): item is McdmOnlyDto {
        return item.clazz === MCDM_ONLY_DTO_CLAZZ_VALUE;
    }

    static isRegulation(item: MeasureDto): item is RegulationDto {
        return item.clazz === REGULATION_DTO_CLAZZ_VALUE;
    }

    static isRerouting(item: MeasureDto): item is ReroutingDto {
        return item.clazz === REROUTING_DTO_CLAZZ_VALUE;
    }

    static isRegulationProposal(item: MeasureDto): item is RegulationProposalDto {
        return item.clazz === REGULATION_PROPOSAL_DTO_CLAZZ_VALUE;
    }

    static isTrafficVolumeLocation(item: LocationDto): item is TrafficVolumeLocationDto {
        return item.clazz === TRAFFIC_VOLUME_LOCATION_DTO_CLAZZ_VALUE;
    }

    static isMcdmMeasureTopic(item: McdmTopic): item is McdmMeasureTopic {
        return item.clazz === MCDM_MEASURE_TOPIC_CLAZZ_VALUE;
    }

    static isMcdmFlightTopic(item: McdmTopic): item is McdmFlightTopic {
        return item.clazz === MCDM_FLIGHT_TOPIC_CLAZZ_VALUE;
    }

    static isMcdmStatefulTopic(item: McdmTopic): item is McdmStatefulTopic {
        return item.clazz === MCDM_MEASURE_TOPIC_CLAZZ_VALUE || item.clazz === MCDM_FLIGHT_TOPIC_CLAZZ_VALUE;
    }

    static isAddFlightToMcdmOnly(item: UpdateFlightInMeasureDto): item is AddFlightToMcdmOnlyDto {
        return item.clazz === ADD_FLIGHT_TO_MCDM_ONLY_DTO_CLAZZ_VALUE;
    }

    static isRemoveFlightFromMcdmOnly(item: UpdateFlightInMeasureDto): item is RemoveFlightFromMcdmOnlyDto {
        return item.clazz === REMOVE_FLIGHT_FROM_MCDM_ONLY_DTO_CLAZZ_VALUE;
    }

    static isAddFlightToRerouting(item: UpdateFlightInMeasureDto): item is AddFlightToReroutingDto {
        return item.clazz === ADD_FLIGHT_TO_REROUTING_DTO_CLAZZ_VALUE;
    }

    static isRemoveFlightFromRerouting(item: UpdateFlightInMeasureDto): item is RemoveFlightFromReroutingDto {
        return item.clazz === REMOVE_FLIGHT_FROM_REROUTING_DTO_CLAZZ_VALUE;
    }

    static isExcludeFlightInRegulation(item: UpdateFlightInMeasureDto): item is ExcludeFlightInRegulationDto {
        return item.clazz === EXCLUDE_FLIGHT_IN_REGULATION_DTO_CLAZZ_VALUE;
    }

    static isReincludeFlightInRegulation(item: UpdateFlightInMeasureDto): item is ReincludeFlightInRegulationDto {
        return item.clazz === REINCLUDE_FLIGHT_IN_REGULATION_DTO_CLAZZ_VALUE;
    }

    static isForceFlightInRegulation(item: UpdateFlightInMeasureDto): item is ForceFlightInRegulationDto {
        return item.clazz === FORCE_FLIGHT_IN_REGULATION_DTO_CLAZZ_VALUE;
    }

    static isUnforceFlightInRegulation(item: UpdateFlightInMeasureDto): item is UnforceFlightInRegulationDto {
        return item.clazz === UNFORCE_FLIGHT_IN_REGULATION_DTO_CLAZZ_VALUE;
    }

    // isRemoveProposalFlight - not defined since only releases < R24.

    static isAvoidViaAirspaceConstraint(item: ReroutingConstraintDto): item is AvoidViaAirspaceReroutingConstraintDto {
        return item.clazz === AVOID_VIA_AIRSPACE_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE;
    }

    static isAvoidViaPointConstraint(item: ReroutingConstraintDto): item is AvoidViaPointReroutingConstraintDto {
        return item.clazz === AVOID_VIA_POINT_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE;
    }

    static isDeltaLevelConstraint(item: ReroutingConstraintDto): item is DeltaLevelReroutingConstraintDto {
        return item.clazz === DELTA_LEVEL_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE;
    }

    static isLevelAndSpeedConstraint(item: ReroutingConstraintDto): item is LevelAndSpeedReroutingConstraintDto {
        return item.clazz === LEVEL_AND_SPEED_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE;
    }

    static isAvoidViaHotspotConstraint(item: ReroutingConstraintDto): item is AvoidViaHotspotReroutingConstraintDto {
        return item.clazz === AVOID_VIA_HOTSPOT_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE;
    }

    static isAvoidViaRegulationConstraint(
        item: ReroutingConstraintDto,
    ): item is AvoidViaRegulationReroutingConstraintDto {
        return item.clazz === AVOID_VIA_REGULATION_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE;
    }

    static getMeasureType(measure: MeasureDto): MeasureType {
        if (measure.measureId) {
            return measure.measureId.type;
        } else if (MeasureUtils.isRegulation(measure) || MeasureUtils.isRegulationProposal(measure)) {
            return MeasureType.REGULATION;
        } else if (MeasureUtils.isRerouting(measure)) {
            return MeasureType.REROUTING;
        } else if (MeasureUtils.isMcdmOnly(measure)) {
            return MeasureType.MCDM_ONLY;
        }
    }

    static getAllowedSubTypes(type: MeasureType): MeasureSubType[] {
        switch (type) {
            case MeasureType.MCDM_ONLY:
                return Object.keys(MeasureSubType) as MeasureSubType[];
            case MeasureType.REGULATION:
                return [MeasureSubType.GROUND_DELAY];
            case MeasureType.REROUTING:
                return [MeasureSubType.GROUND_HORIZONTAL_REROUTING, MeasureSubType.GROUND_LEVEL_CAP];
        }
    }

    /**
     * Compute the flight list [WEF, UNT[ time period corresponding to a regulation applicability period.
     *
     * When requiring REGULATED_DEMAND or LOAD, the method with add on an extra minute to UNT, to capture
     * any overload flights.
     *
     * Extra checks must be done to prevent
     *  a) flight list WEF commencing before minPossibleDay
     *  b) flight list UNT not going beyond 24hr.
     *
     * @param applicability
     * @param ttype
     * @param minPossibleDay
     */
    static getFlightListTimePeriodForMeasure(
        applicability: TimePeriod,
        ttype: TrafficType,
        minPossibleDay?: Date,
    ): TimePeriod {
        if (minPossibleDay) {
            if (applicability.to.getTime() < minPossibleDay.getTime()) return null;
        }
        // note : the GWT code also had logic to restrict to start of day
        const wef = TimeUtils.max(applicability.from, minPossibleDay);
        let unt = ttype === TrafficType.DEMAND ? applicability.to : TimeUtils.addMinutes(applicability.to, 1);

        if (TimeUtils.diffInMs(unt, wef) > TimeUtils.DAY_TO_MS) {
            unt = TimeUtils.addDays(wef, 1);
        }
        return { from: wef, to: unt };
    }

    /**
     * Determine if regulation proposals can be used.
     * For simulations and forecast datasets, we cannot use regulation proposals, since there is no human operator
     * to accept the proposal.
     * @param dataset
     * @param regulation
     * @return
     */
    static canUseRegulationProposals(dataset: DatasetDto): boolean {
        switch (dataset.type) {
            case DatasetType.SIMULATION:
                return false;
            case DatasetType.FORECAST:
            case DatasetType.OPERATIONAL:
                return true;
        }
        return undefined;
    }

    /**
     * Utility function to return the TvLocation of a Measure.
     * This method is needed since currently the location attribute is not at the MeasureDto level
     * (Due to fact, *in theory*, that Reroutings could have various different location types.
     *  Although in practice it is always a TvLocation)
     * @param measure
     * @return
     */
    static getTvLocation(measure: MeasureDto): TrafficVolumeLocationDto {
        if (
            MeasureUtils.isRegulation(measure) ||
            MeasureUtils.isRegulationProposal(measure) ||
            MeasureUtils.isMcdmOnly(measure)
        ) {
            return measure.location;
        } else if (MeasureUtils.isRerouting(measure) && MeasureUtils.isTrafficVolumeLocation(measure.location)) {
            return measure.location;
        }
    }

    /**
     * Utility function to set the TvLocation of a Measure.
     * This method is needed since currently the location attribute is not at the MeasureDto level
     * (Due to fact, *in theory*, that Reroutings could have various different location types.
     *  Although in practice it is always a TvLocation)
     * @param measure
     * @param location
     */
    static setTvLocation(measure: MeasureDto, location: TrafficVolumeLocationDto) {
        if (
            MeasureUtils.isRegulation(measure) ||
            MeasureUtils.isRegulationProposal(measure) ||
            MeasureUtils.isMcdmOnly(measure)
        ) {
            measure.location = location;
        } else if (MeasureUtils.isRerouting(measure)) {
            measure.location = location;
        }
    }

    static toLocationString(measure: MeasureDto): string {
        if (
            measure.clazz === REGULATION_OR_MCDM_ONLY_DTO_CLAZZ_VALUE ||
            measure.clazz === MCDM_ONLY_DTO_CLAZZ_VALUE ||
            measure.clazz === REGULATION_DTO_CLAZZ_VALUE ||
            measure.clazz === REGULATION_PROPOSAL_DTO_CLAZZ_VALUE
        ) {
            return MeasureUtils.locationToLocationString((measure as RegulationOrMcdmOnlyDto).location);
        } else if (measure.clazz === REROUTING_DTO_CLAZZ_VALUE) {
            return MeasureUtils.locationToLocationString((measure as ReroutingDto).location);
        } else {
            return '??';
        }
    }

    static toRefLocationString(measure: MeasureDto): string {
        if (
            measure.clazz === REGULATION_OR_MCDM_ONLY_DTO_CLAZZ_VALUE ||
            measure.clazz === MCDM_ONLY_DTO_CLAZZ_VALUE ||
            measure.clazz === REGULATION_DTO_CLAZZ_VALUE ||
            measure.clazz === REGULATION_PROPOSAL_DTO_CLAZZ_VALUE
        ) {
            return MeasureUtils.locationToRefLocationString((measure as RegulationOrMcdmOnlyDto).location);
        } else if (measure.clazz === REROUTING_DTO_CLAZZ_VALUE) {
            return MeasureUtils.locationToRefLocationString((measure as ReroutingDto).location);
        } else {
            return '??';
        }
    }

    static getRegulationState(measure: MeasureDto): RegulationState {
        if (measure.clazz === REGULATION_DTO_CLAZZ_VALUE) {
            return (measure as RegulationDto).regulationState;
        } else if (measure.clazz === MCDM_ONLY_DTO_CLAZZ_VALUE) {
            return (measure as McdmOnlyDto).mcdmOnlyState;
        } else if (measure.clazz === REGULATION_PROPOSAL_DTO_CLAZZ_VALUE) {
            return (measure as RegulationProposalDto).regulationState;
        } else {
            return undefined;
        }
    }

    static locationToLocationString(location: LocationDto): string {
        if (location.clazz === TRAFFIC_VOLUME_LOCATION_DTO_CLAZZ_VALUE) {
            return (location as TrafficVolumeLocationDto).id;
        } else {
            return '??';
        }
    }

    static locationToRefLocationString(location: LocationDto): string {
        if (location.clazz === TRAFFIC_VOLUME_LOCATION_DTO_CLAZZ_VALUE) {
            const tvLocation: TrafficVolumeLocationDto = location;
            return AirspaceUtils.toTvRefLocationString(tvLocation.refLocation);
        }
    }

    static toLFRSString(regul: RegulationDto): string {
        let L, F, R, S;
        L = F = R = S = ' ';
        const numLinked = regul.linkedRegulations?.length || 0;
        if (regul.autoLink) {
            L = numLinked > 0 ? 'L' : 'A';
        } else {
            L = numLinked > 0 ? 'M' : ' ';
        }
        if (MeasureUtils.isEntryRegulation(regul)) {
            for (const con of regul.initialConstraints) {
                if (con.exceptionalConstraint) {
                    const exc = con.exceptionalConstraint;
                    if (exc.fcmMandatory) F = 'F';
                    if (exc.rvr !== -1) R = 'R';
                    if (exc.shift) S = 'S';
                }
            }
        }
        return L + F + R + S;
    }

    static getInitialConstraintsString(measure: RegulationOrMcdmOnlyDto): string {
        let result = '';
        if (MeasureUtils.isEntryRegulation(measure)) {
            for (let i = 0; i < measure.initialConstraints.length; i++) {
                const ric = measure.initialConstraints[i];
                if (i > 0) result += '\n';
                const rate = ric.normalRate + ric.pendingRate + ric.equipmentRate;
                result += TimePeriodUtils.formatDDHHMM(ric.timePeriod) + ' : ' + rate;
            }
        } else {
            for (let i = 0; i < measure.occupancyConstraints.length; i++) {
                const ric = measure.occupancyConstraints[i];
                if (i > 0) result += '\n';
                const rate = 'P=' + ric.peakCapacity + ', S=' + MeasureUtils.getOccupancyRate(ric);
                result += TimePeriodUtils.formatDDHHMM(ric.timePeriod) + ' : ' + rate;
            }
        }
        return result;
    }

    static toHotspotShortString(hotspotId: HotspotId): string {
        return (
            hotspotId.tvId +
            '/' +
            hotspotId.durationInMinutes +
            ' [' +
            TimePeriodUtils.formatHHMM(hotspotId.timePeriod) +
            ']'
        );
    }

    static toHotspotSeverityShortString(severity: HotspotSeverity): string {
        switch (severity) {
            case HotspotSeverity.HIGH:
                return 'HIG';
            case HotspotSeverity.LOW:
                return 'LOW';
            case HotspotSeverity.MEDIUM:
                return 'MED';
        }
        return '??';
    }

    static toHotspotStatusShortString(status: HotspotStatus): string {
        switch (status) {
            case HotspotStatus.ACCEPTABLE:
                return 'ACPT';
            case HotspotStatus.ACTIVE:
                return 'ACTV';
            case HotspotStatus.DRAFT:
                return 'DRFT';
            case HotspotStatus.SOLVED:
                return 'SLVD';
        }
    }

    static toScenarioMatchShortString(kind: ScenarioTvMatchingKind): string {
        if (kind) {
            switch (kind) {
                case ScenarioTvMatchingKind.INDIRECT_OFFLOAD:
                    return 'IND';
                case ScenarioTvMatchingKind.OVERLAPPING_REFERENCE_LOCATION:
                    return 'ORL';
                case ScenarioTvMatchingKind.SAME_REFERENCE_LOCATION:
                    return 'SRL';
                case ScenarioTvMatchingKind.SAME_TRAFFIC_VOLUME:
                    return 'STV';
            }
            return '??';
        }
    }

    static toMeasureTypeShortString(type: MeasureType) {
        if (type) {
            switch (type) {
                case MeasureType.MCDM_ONLY:
                    return 'MCDM';
                case MeasureType.REGULATION:
                    return 'REG';
                case MeasureType.REROUTING:
                    return 'RRT';
            }
            return '??';
        }
    }

    /**
     * @deprecated old GWT code had a 'getXXX' named method - please use the 'toXXX' method
     */
    static getMeasureTypeShortString(type: MeasureType) {
        return MeasureUtils.toMeasureTypeShortString(type);
    }

    static toMeasureSubTypeShortString(measureSubType: MeasureSubType) {
        if (measureSubType) {
            switch (measureSubType) {
                case MeasureSubType.AIRBORNE_HORIZONTAL_REROUTING:
                    return 'AHRER';
                case MeasureSubType.AIRBORNE_LEVEL_CAP:
                    return 'ALCAP';
                case MeasureSubType.GROUND_DELAY:
                    return 'GDLAY';
                case MeasureSubType.GROUND_HORIZONTAL_REROUTING:
                    return 'GHRER';
                case MeasureSubType.GROUND_LEVEL_CAP:
                    return 'GLCAP';
                case MeasureSubType.MILES_MINUTES_IN_TRAIL:
                    return 'TRAIL';
                case MeasureSubType.MINIMUM_DEPARTURE_INTERVAL:
                    return 'MDI';
                case MeasureSubType.OTHER_KIND_OF_STAM_MEASURE:
                    return 'OTHER';
                case MeasureSubType.TAKE_OFF_NOT_AFTER:
                    return 'TONA';
                case MeasureSubType.TAKE_OFF_NOT_BEFORE:
                    return 'TONB';
                case MeasureSubType.TERMINAL_PROCEDURE_CHANGE:
                    return 'TPCHG';
            }
            return '??';
        }
    }

    static toRegulationCauseShortString(dto: RegulationCauseDto) {
        if (dto) {
            return (
                MeasureUtils.toRegulationReasonShortString(dto.reason) +
                MeasureUtils.toRegulationLocationCategoryShortString(dto.locationCategory) +
                Utils.leftPadZero(dto.iataDelayCode, 2)
            );
        }
    }

    static toRegulationReasonShortString(reason: RegulationReasonType): string {
        switch (reason) {
            case RegulationReasonType.ACCIDENT_INCIDENT:
                return 'A';
            case RegulationReasonType.AERODROME_CAPACITY:
                return 'G';
            case RegulationReasonType.AERODROME_SERVICES:
                return 'E';
            case RegulationReasonType.AIRSPACE_MANAGEMENT:
                return 'M';
            case RegulationReasonType.ATC_CAPACITY:
                return 'C';
            case RegulationReasonType.ATC_EQUIPMENT:
                return 'T';
            case RegulationReasonType.ATC_INDUSTRIAL_ACTION:
                return 'I';
            case RegulationReasonType.ATC_ROUTINGS:
                return 'R';
            case RegulationReasonType.ATC_STAFFING:
                return 'S';
            case RegulationReasonType.ENVIRONMENTAL_ISSUES:
                return 'V';
            case RegulationReasonType.NON_ATC_INDUSTRIAL_ACTION:
                return 'N';
            case RegulationReasonType.OTHERS:
                return 'O';
            case RegulationReasonType.SPECIAL_EVENT:
                return 'P';
            case RegulationReasonType.WEATHER:
                return 'W';
        }
        return '?';
    }

    static toRegulationOutlookReasonString(reason: RegulationReasonType): string {
        // Only handle the reasons presents in the RegOutlook service
        switch (reason) {
            case RegulationReasonType.WEATHER:
                return 'WEATHER';
            case RegulationReasonType.ATC_CAPACITY:
                return 'ATC_CAP';
            case RegulationReasonType.AERODROME_CAPACITY:
                return 'AD_CAP';
            case RegulationReasonType.ATC_INDUSTRIAL_ACTION:
                return 'ATC_IND';
            case RegulationReasonType.OTHERS:
                return 'OTHER';
            case RegulationReasonType.SPECIAL_EVENT:
                return 'EVENT';
            default:
                return MeasureUtils.toRegulationReasonString(reason);
        }
    }

    static toRegulationLocationCategoryShortString(loc: RegulationLocationCategory): string {
        switch (loc) {
            case RegulationLocationCategory.ARRIVAL:
                return 'A';
            case RegulationLocationCategory.DEPARTURE:
                return 'D';
            case RegulationLocationCategory.ENROUTE:
                return 'E';
        }
        return '?';
    }

    static toStateShortString(state: McdmState): string {
        if (state) {
            switch (state) {
                case McdmState.ABANDONED:
                    return 'ABANDON';
                case McdmState.COORDINATED:
                    return 'COORD';
                case McdmState.DRAFT:
                    return 'DRAFT';
                case McdmState.FINISHED:
                    return 'FINISHED';
                case McdmState.IMPLEMENTED:
                    return 'IMPLTED';
                case McdmState.IMPLEMENTING:
                    return 'FOR IMPL';
                case McdmState.INTERRUPTED:
                    return 'INTRUPT';
                case McdmState.PROPOSED:
                    return 'PROP';
            }
            return '???'; // should never happen
        }
    }

    static toStateString(state: McdmState): string {
        if (state) {
            switch (state) {
                case McdmState.ABANDONED:
                    return 'ABANDONED';
                case McdmState.COORDINATED:
                    return 'COORDINATED';
                case McdmState.DRAFT:
                    return 'DRAFT';
                case McdmState.FINISHED:
                    return 'FINISHED';
                case McdmState.IMPLEMENTED:
                    return 'IMPLEMENTED';
                case McdmState.IMPLEMENTING:
                    return 'FOR IMPLEMENTATION';
                case McdmState.INTERRUPTED:
                    return 'INTERRUPTED';
                case McdmState.PROPOSED:
                    return 'PROPOSED';
            }
            return '???'; // should never happen
        }
    }

    static toMcdmMeasureStateString(mcdmMeasureTopic: McdmMeasureTopic): string {
        const approvalState = MeasureUtils.getNMOCApprovalState(mcdmMeasureTopic);
        const mcdmState = mcdmMeasureTopic.state;

        // We can't completely rely on the MCDMApprovalState, because it doesn't get updated to "OK"/"REJECTED",
        // when we accept/reject the proposal in NMVP, thus we check the mcdm state which is more reliable
        if (approvalState === McdmApprovalState.UNKNOWN) {
            return AuthorisationUtils.isFmpUser() ? 'PROPOSED' : 'OPEN PROPOSAL';
        } else if (MeasureUtils.isMcdmStateActive(mcdmState)) {
            return mcdmMeasureTopic.remark !== undefined ? `WORK IN PROGRESS` : 'ACKNOWLEDGED';
        } else {
            return mcdmState;
        }
    }

    static toActionShortString(action: RegulationProposalAction): string {
        if (action) {
            switch (action) {
                case RegulationProposalAction.CANCELLATION:
                    return 'CANCEL';
                case RegulationProposalAction.CREATION:
                    return 'CREATE';
                case RegulationProposalAction.UPDATE:
                    return 'UPDATE';
            }
            return '??';
        }
    }

    static toRegulationStateShortString(state: RegulationState): string {
        if (!state) return '???';
        switch (state) {
            case RegulationState.APPLIED:
                return 'APLD';
            case RegulationState.APPLYING:
                return 'APLG';
            case RegulationState.CANCELLED:
                return 'CNCD';
            case RegulationState.CANCELLING:
                return 'CNCG';
            case RegulationState.TERMINATED:
                return 'TERM';
        }
        return '???';
    }

    static toDaysOFWeekString(dto: DaysOfWeekPresence): string {
        if (dto) {
            const nonPresenceStr = 'x';
            let str: string = '';
            str += dto.monday ? '1' : nonPresenceStr;
            str += dto.tuesday ? '2' : nonPresenceStr;
            str += dto.wednesday ? '3' : nonPresenceStr;
            str += dto.thursday ? '4' : nonPresenceStr;
            str += dto.friday ? '5' : nonPresenceStr;
            str += dto.saturday ? '6' : nonPresenceStr;
            str += dto.sunday ? '7' : nonPresenceStr;
            return str;
        }
    }

    static fromDaysOfWeekString(str: string): DaysOfWeekPresence {
        if (str) {
            const reply: DaysOfWeekPresence = {};
            reply.monday = str[0] === '1';
            reply.tuesday = str[1] === '2';
            reply.wednesday = str[2] === '3';
            reply.thursday = str[3] === '4';
            reply.friday = str[4] === '5';
            reply.saturday = str[5] === '6';
            reply.sunday = str[6] === '7';
            return reply;
        }
    }

    static getMcdmTopicImplementers(topic: McdmStatefulTopic): string[] {
        const reply: string[] = [];
        if (topic.initiatorIsImplementer) {
            reply.push(topic.initatorId);
        }
        if (topic.userRoleAndApprovalStates) {
            for (const ras of topic.userRoleAndApprovalStates) {
                if (ras.role === McdmRole.IMPLEMENTER) {
                    reply.push(ras.userId);
                }
            }
        }
        return reply;
    }

    // Temporarily removed - we have measure.measureId .. but need to decide where we place @JsonIgnores .. either on measureId or the specific xxxId fields.
    // static getMeasureId(item: MeasureDto) : MeasureId{
    //     if (MeasureUtils.isRegulation(item)) return {type : MeasureType.REGULATION, id : item.regulId};
    //     if (MeasureUtils.isRegulationProposal(item)) return {type : MeasureType.REGULATION, id : item.regulId};
    //     if (MeasureUtils.isRerouting(item)) return {type : MeasureType.REROUTING, id : item.reroutingId};
    //     if (MeasureUtils.isMcdmOnly(item)) return {type : MeasureType.MCDM_ONLY, id : item.mcdmOnlyId};
    // }

    public static getApprovalSummaryString(topic: McdmStatefulTopic): string {
        if (topic.userRoleAndApprovalStates) {
            let numApproved = 0,
                numRejected = 0,
                numStandby = 0,
                numUnknown = 0;
            for (const ras of topic.userRoleAndApprovalStates) {
                switch (ras.approvalState) {
                    case McdmApprovalState.ACKNOWLEDGED:
                        numStandby++;
                        break;
                    case McdmApprovalState.APPROVED:
                        numApproved++;
                        break;
                    case McdmApprovalState.REJECTED:
                        numRejected++;
                        break;
                    case McdmApprovalState.UNKNOWN:
                        if (MeasureUtils.canVote(topic, ras.userId)) {
                            numUnknown++;
                        }
                        break;
                }
            }
            return 'OK=' + numApproved + ' NOK=' + numRejected + ' STBY=' + numStandby + ' ?=' + numUnknown;
        }
    }

    public static canVote(topic: McdmStatefulTopic, anuId: string): boolean {
        const ras = MeasureUtils.getUserRoleAndApprovalState(topic, anuId);
        return ras?.role === McdmRole.APPROVAL || (ras?.role === McdmRole.IMPLEMENTER && !topic.initiatorIsImplementer);
    }

    public static canChangeState(topic: McdmStatefulTopic, anuId: string): boolean {
        switch (topic.state) {
            case McdmState.IMPLEMENTED:
            case McdmState.IMPLEMENTING:
                return MeasureUtils.isImplementer(topic, anuId);
            case McdmState.ABANDONED:
            case McdmState.INTERRUPTED:
                return false;
            default:
                return MeasureUtils.isInitiator(topic, anuId);
        }
    }

    public static isInitiator(topic: McdmStatefulTopic, anuId: string): boolean {
        if (topic.initatorId === anuId) return true;
        const ras = MeasureUtils.getUserRoleAndApprovalState(topic, anuId);
        return ras?.role === McdmRole.INITIATOR;
    }

    public static isImplementer(topic: McdmStatefulTopic, anuId: string): boolean {
        if (topic.initiatorIsImplementer && topic.initatorId === anuId) return true;
        const ras = MeasureUtils.getUserRoleAndApprovalState(topic, anuId);
        return ras?.role === McdmRole.IMPLEMENTER;
    }

    public static getUserRoleAndApprovalState(topic: McdmStatefulTopic, anuId: string): McdmUserRoleAndApprovalState {
        if (topic.userRoleAndApprovalStates) {
            return topic.userRoleAndApprovalStates.find(ras => ras.userId === anuId);
        }
    }

    public static getNextExpectedState(state: McdmState): McdmState {
        switch (state) {
            case McdmState.DRAFT:
                return McdmState.PROPOSED;
            case McdmState.PROPOSED:
                return McdmState.IMPLEMENTING;
            case McdmState.COORDINATED:
                return McdmState.IMPLEMENTING;
            case McdmState.IMPLEMENTING:
                return McdmState.IMPLEMENTED;
            case McdmState.IMPLEMENTED:
                return McdmState.FINISHED;
            default:
                return state;
        }
    }

    public static getEhelpDeskTicketTypeString(choice: EHelpDeskTicketChoiceDto) {
        if (choice) {
            if (choice.excludeFlightFromRegulation) return 'EXCLUDE';
            if (choice.extendSlotInRegulation) return 'EXTEND';
            if (choice.forceFlightsInRegulation) return 'FORCE';
            if (choice.improveSlotInRegulation) return 'IMPROVE';
            if (choice.information) return 'INFO';
            if (choice.other) return 'OTHER';
            if (choice.reIncludeFlightInRegulation) return 'INCLUDE';
            if (choice.swapSlotsInRegulation) return 'SWAP';
            if (choice.unforceFlightsInRegulation) return 'UNFORCE';
            return '???';
        }
    }

    public static getAllTopics(list: McdmTopicList): McdmTopic[] {
        const reply: McdmTopic[] = [];
        if (list.measures) {
            for (const topic of list.measures) {
                reply.push(topic);
                if (topic.flightTopics) {
                    reply.push(...topic.flightTopics);
                }
            }
        }
        if (list.standaloneFlights) {
            reply.push(...list.standaloneFlights);
        }
        return reply;
    }

    static getEHelpDeskTicket(choice: EHelpDeskTicketChoiceDto): EHelpDeskTicketDto {
        let ticket = null;
        if (choice.excludeFlightFromRegulation) {
            ticket = choice.excludeFlightFromRegulation;
        } else if (choice.extendSlotInRegulation) {
            ticket = choice.extendSlotInRegulation;
        } else if (choice.improveSlotInRegulation) {
            ticket = choice.improveSlotInRegulation;
        } else if (choice.information) {
            ticket = choice.information;
        } else if (choice.other) {
            ticket = choice.other;
        } else if (choice.reIncludeFlightInRegulation) {
            ticket = choice.reIncludeFlightInRegulation;
        } else if (choice.swapSlotsInRegulation) {
            ticket = choice.swapSlotsInRegulation;
        } else if (choice.forceFlightsInRegulation) {
            // assuming only one fligh in list!
            ticket = choice.forceFlightsInRegulation.flights[0];
        } else if (choice.unforceFlightsInRegulation) {
            // assuming only one fligh in list!
            ticket = choice.unforceFlightsInRegulation.flights[0];
        } else {
            throw 'Unknown EhelpDeskTicketChoice ' + choice;
        }
        return ticket;
    }

    /**
     * Construct a Regulation Proposal from a given Regulation.
     * This method does a shallow copy (i.e. so no deep copy of embedded data structures) of all shared attributes.
     * The specific Regulation Proposal attributes (e.g. kind, action) are not filled in.
     *
     * @param regulation
     * @param action
     */
    static createProposalFromRegulation(
        regulation: RegulationDto,
        action?: RegulationProposalAction,
    ): RegulationProposalDto {
        return {
            clazz: REGULATION_PROPOSAL_DTO_CLAZZ_VALUE,
            measureId: regulation.measureId,
            applicability: regulation.applicability,
            cherryPicking: regulation.cherryPicking,
            externallyEditable: regulation.externallyEditable,
            subType: regulation.subType,
            createdByFmp: regulation.createdByFmp,
            mcdmRequired: regulation.mcdmRequired,
            sourceHotspot: regulation.sourceHotspot,
            //           dataId : regulation.dataId,
            scenarioReference: regulation.scenarioReference,
            mcdmInfo: regulation.mcdmInfo,
            reason: regulation.reason,
            location: regulation.location,
            initialConstraints: regulation.initialConstraints,
            occupancyConstraints: regulation.occupancyConstraints,
            occupancyDurationInMs: regulation.occupancyDurationInMs,
            calculationType: regulation.calculationType,
            supplementaryConstraints: regulation.supplementaryConstraints,
            remark: Utils.isNotEmptyString(regulation.remark) ? regulation.remark : 'NONE.', // Real regulations sometimes omit this field.
            autoLink: regulation.autoLink,
            linkedRegulations: regulation.linkedRegulations,
            noDelayWindowInMs: regulation.noDelayWindowInMs,
            updateCapacityRequired: regulation.updateCapacityRequired,
            updateTvActivationRequired: regulation.updateTvActivationRequired,
            delayTvSetId: regulation.delayTvSetId,
            delayConfirmationThresholdInMs: regulation.delayConfirmationThresholdInMs,

            // = this values cannot be fully determined, since they depend on the context
            kind: regulation.cherryPicking
                ? undefined
                : RegulationProposalKind.RegulationProposalWithoutProposalFlights,
            action: action,
        };
    }

    static toFlightResultListErrorString<T>(dto: FlightResultList<T>) {
        let reply = '';
        for (const failure of dto.failures) {
            reply += failure.flightKeys.callsign + ' : ' + failure.reason + '\n';
        }
        return reply;
    }

    /**
     * Returns the time that is merged with a day that corresponds to the time period, or the dayIfMissing
     * @param time
     * @param period
     * @param dayIfMissing
     */
    static adaptTimeToPeriod(time: Date, period: TimePeriod, dayIfMissing?: Date): Date {
        if (!time) return undefined;

        let day;
        if (period?.from) {
            day = TimeUtils.withoutTimeOfDay(period?.from);
            if (TimeUtils.timeSinceMidnightInMs(time) < TimeUtils.timeSinceMidnightInMs(period?.from)) {
                day = TimeUtils.addDays(day, 1);
            }
        } else if (period?.to) {
            day = TimeUtils.withoutTimeOfDay(period?.to);
            if (TimeUtils.timeSinceMidnightInMs(time) >= TimeUtils.timeSinceMidnightInMs(period?.to)) {
                day = TimeUtils.addDays(day, -1);
            }
        } else {
            day = dayIfMissing;
        }
        return TimeUtils.mergeDateAndTime(day, time);
    }

    /**
     * Adapts regulation constraint periods to ensure their consistency with measure applicability period
     * @param dto
     * @param isInitialConstraintsUpdate
     * @param isOccupancyConstraintsUpdate
     */
    static adaptConstraintPeriods(
        dto: RegulationOrMcdmOnlyDto,
        isInitialConstraintsUpdate: boolean,
        isOccupancyConstraintsUpdate?: boolean,
    ): RegulationOrMcdmOnlyDto {
        if (Utils.isNotEmpty(dto.initialConstraints)) {
            // Make a copy of the array (state mgt), and sort the constraints
            dto.initialConstraints = dto.initialConstraints
                .slice()
                .sort((a, b) => TimePeriodUtils.COMPARE_FUNCTION(a.timePeriod, b.timePeriod));

            // When applicability period "shrinks", remove "obsolete" constraints that ends before or starts after the new period
            if (dto.applicability?.to && dto.applicability?.from && !isInitialConstraintsUpdate) {
                dto.initialConstraints = dto.initialConstraints.filter(
                    constraint =>
                        !constraint.timePeriod?.from ||
                        TimeUtils.compare(constraint.timePeriod.from, dto.applicability.to) < 0,
                );
            }

            for (let i = 0; i < dto.initialConstraints.length; i++) {
                let { from, to } = dto.initialConstraints[i].timePeriod || {};

                if (i === 0) {
                    if (isInitialConstraintsUpdate && from) {
                        dto.applicability = produce(dto.applicability, update => {
                            update.from = new Date(from);
                        });
                    }

                    from = dto.applicability?.from ? new Date(dto.applicability.from) : from;
                } else {
                    from = MeasureUtils.adaptTimeToPeriod(
                        dto.initialConstraints[i].timePeriod?.from,
                        dto.applicability,
                        AppContext.getMonitoredDay(),
                    );
                }

                if (i === dto.initialConstraints.length - 1) {
                    // When last constraint starts at/after the regulation's end period, extend the regulation period by 20min
                    if (
                        dto.initialConstraints[i].timePeriod?.from &&
                        dto.applicability?.to &&
                        TimeUtils.compare(dto.initialConstraints[i].timePeriod.from, dto.applicability.to) >= 0
                    ) {
                        dto.applicability = produce(dto.applicability, update => {
                            update.to = new Date(TimeUtils.addMinutes(dto.initialConstraints[i].timePeriod.from, 20));
                        });
                    }

                    to = dto.applicability?.to ? new Date(dto.applicability.to) : to;
                } else {
                    const startOfNextConstraint = dto.initialConstraints[i + 1]?.timePeriod?.from;
                    // In case next constraint is empty (no from), set the "To" to end of regulation
                    const constraintTo = startOfNextConstraint || dto.applicability.to;
                    to = MeasureUtils.adaptTimeToPeriod(constraintTo, dto.applicability, AppContext.getMonitoredDay());
                }

                dto.initialConstraints = produce(dto.initialConstraints, update => {
                    update[i].timePeriod = { from, to };
                });
            }
        }
        if (Utils.isNotEmpty(dto.supplementaryConstraints)) {
            dto.supplementaryConstraints = dto.supplementaryConstraints.slice(); // Make a copy of the array (state mgt)
            for (let i = 0; i < dto.supplementaryConstraints.length; i++) {
                const supplementaryConstraint = dto.supplementaryConstraints[i];
                supplementaryConstraint.timePeriod = {
                    from: MeasureUtils.adaptTimeToPeriod(
                        supplementaryConstraint.timePeriod?.from,
                        dto.applicability,
                        AppContext.getMonitoredDay(),
                    ),
                    to: MeasureUtils.adaptTimeToPeriod(
                        supplementaryConstraint.timePeriod?.to,
                        dto.applicability,
                        AppContext.getMonitoredDay(),
                    ),
                };
            }
        }
        if (Utils.isNotEmpty(dto.occupancyConstraints)) {
            // Make a copy of the array (state mgt), and sort the constraints
            dto.occupancyConstraints = dto.occupancyConstraints
                .slice()
                .sort((a, b) => TimePeriodUtils.COMPARE_FUNCTION(a.timePeriod, b.timePeriod));

            // When applicability period "shrinks", remove "obsolete" constraints that ends before or starts after the new period
            if (dto.applicability?.to && dto.applicability?.from && !isOccupancyConstraintsUpdate) {
                dto.occupancyConstraints = dto.occupancyConstraints.filter(
                    constraint =>
                        !constraint.timePeriod?.from ||
                        TimeUtils.compare(constraint.timePeriod.from, dto.applicability.to) < 0,
                );
            }

            for (let i = 0; i < dto.occupancyConstraints.length; i++) {
                let { from, to } = dto.occupancyConstraints[i].timePeriod || {};

                if (i === 0) {
                    if (isOccupancyConstraintsUpdate && from) {
                        dto.applicability = produce(dto.applicability, update => {
                            update.from = new Date(from);
                        });
                    }

                    from = dto.applicability?.from ? new Date(dto.applicability.from) : from;
                } else {
                    from = MeasureUtils.adaptTimeToPeriod(
                        dto.occupancyConstraints[i].timePeriod?.from,
                        dto.applicability,
                        AppContext.getMonitoredDay(),
                    );
                }

                if (i === dto.occupancyConstraints.length - 1) {
                    // When last constraint starts at/after the regulation's end period, extend the regulation period by 20min
                    if (
                        dto.occupancyConstraints[i].timePeriod?.from &&
                        dto.applicability?.to &&
                        TimeUtils.compare(dto.occupancyConstraints[i].timePeriod.from, dto.applicability.to) >= 0
                    ) {
                        dto.applicability = produce(dto.applicability, update => {
                            update.to = new Date(TimeUtils.addMinutes(dto.occupancyConstraints[i].timePeriod.from, 20));
                        });
                    }

                    to = dto.applicability?.to ? new Date(dto.applicability.to) : to;
                } else {
                    const startOfNextConstraint = dto.occupancyConstraints[i + 1]?.timePeriod?.from;
                    // In case next constraint is empty (no from), set the "To" to end of regulation
                    const constraintTo = startOfNextConstraint || dto.applicability.to;
                    to = MeasureUtils.adaptTimeToPeriod(constraintTo, dto.applicability, AppContext.getMonitoredDay());
                }

                dto.occupancyConstraints = produce(dto.occupancyConstraints, update => {
                    update[i].timePeriod = { from, to };
                });
            }
        }
        return dto;
    }

    static toLoadClassification(averageDelayMs: number) {
        let lc = LoadClassification.UNDEFINED;
        if (averageDelayMs > 45 * TimeUtils.MIN_TO_MS) {
            lc = LoadClassification.OVERLOAD;
        } else if (averageDelayMs > 30 * TimeUtils.MIN_TO_MS) {
            lc = LoadClassification.HIGH_THRESHOLD;
        } else if (averageDelayMs > 15 * TimeUtils.MIN_TO_MS) {
            lc = LoadClassification.LOW_THRESHOLD;
        } else {
            lc = LoadClassification.NORMAL;
        }
        return lc;
    }

    static getFillColor(loadClassification: LoadClassification) {
        switch (loadClassification) {
            case LoadClassification.NORMAL: // < 15mn
                return '#595959';
            case LoadClassification.LOW_THRESHOLD: // > 15mn
                return '#8C8C8C';
            case LoadClassification.HIGH_THRESHOLD: // > 30mn
                return '#BFBFBF';
            case LoadClassification.OVERLOAD: // > 45mn
                return '#FFFFFF';
            case LoadClassification.UNDEFINED:
            default:
                return 'rgba(0, 0, 0, 0.0)';
        }
    }

    static isValidInitialConstraint(constraint: RegInitialConstraint): boolean {
        return (
            Utils.isExists(constraint?.timePeriod?.from) &&
            (Utils.isExists(constraint?.normalRate) ||
                Utils.isExists(constraint?.pendingRate) ||
                Utils.isExists(constraint?.equipmentRate))
        );
    }

    static isValidOccupancyConstraint(constraint: RegulationOccupancyConstraintDto): boolean {
        return (
            Utils.isExists(constraint?.timePeriod?.from) &&
            Utils.isExists(constraint?.occupancyRate) &&
            Utils.isExists(constraint?.peakCapacity)
        );
    }

    static isValidForSimulation(regulation: RegulationDto): boolean {
        return (
            Utils.isNotEmptyString(regulation?.measureId?.id) &&
            Utils.isNotEmptyString(regulation?.location?.id) &&
            (Utils.isExists(regulation?.applicability?.from) || Utils.isExists(regulation?.applicability?.to)) &&
            ((MeasureUtils.isEntryRegulation(regulation) &&
                regulation?.initialConstraints?.length >= 1 &&
                regulation?.initialConstraints.every(value => MeasureUtils.isValidInitialConstraint(value)) &&
                regulation?.initialConstraints.some(value => MeasureUtils.getRate(value) >= 0)) || // At least of the constraint has to be different than 0
                (MeasureUtils.isOccupancyRegulation(regulation) &&
                    regulation?.occupancyConstraints?.length >= 1 &&
                    regulation?.occupancyConstraints.every(value => MeasureUtils.isValidOccupancyConstraint(value))))
        );
    }

    static hasTimePeriod(regulation: RegulationDto): boolean {
        return (
            regulation?.initialConstraints?.length === 1 && // TODO: Remove this limitation when time will permit
            regulation?.initialConstraints.every(
                value => Utils.isExists(value.timePeriod?.from) && Utils.isExists(value.timePeriod?.to),
            )
        );
    }

    static getOccupancyRate(constraint: RegulationOccupancyConstraintDto) {
        const rate = constraint.occupancyRate || 0;
        const pendingPercentage = (constraint.pendingCapacityPercentage || 0) / 100;
        return rate * (1 + pendingPercentage);
    }

    static getRate(constraint: RegInitialConstraint) {
        return (constraint.normalRate || 0) + (constraint.pendingRate || 0) + (constraint.equipmentRate || 0);
    }

    static calculateAutoPeriod(regulation: RegulationDto, flights: Array<FlightDto>): TimePeriod {
        flights.sort((a, b) =>
            TimeUtils.diffInMs(a.timeAtReferenceLocationEntry?.time, b.timeAtReferenceLocationEntry?.time),
        );

        const lastFlightEntry = flights[flights.length - 1]?.timeAtReferenceLocationEntry?.time;

        // TODO: deal with multiple constraints
        // Ensure that rate is not null
        const constraint = regulation.initialConstraints[0];
        const rate = MeasureUtils.getRate(constraint);
        if (rate <= 0) return undefined;

        const regStartTime = constraint.timePeriod.from;

        // Calculate an approximation of the regulation end time that would allow enough slots given the constraints and the flights list
        const COUNTING_INTERVAL = 20;
        let countingPeriod = { from: regStartTime, to: TimeUtils.addMinutes(regStartTime, COUNTING_INTERVAL) };
        const ratePerPeriod = (rate * COUNTING_INTERVAL) / 60;
        let nbReportedFlights = 0;
        let noOverloadPeriod;
        let regEndTime;
        while (!regEndTime) {
            if (TimeUtils.diffInMs(countingPeriod.from, lastFlightEntry) >= 0) {
                regEndTime = lastFlightEntry; // Reached the end of flight list
            } else {
                const nbFlights = MeasureUtils.getFlightsInPeriod(flights, countingPeriod).length;
                nbReportedFlights = nbReportedFlights + nbFlights - ratePerPeriod;
                //nbReportedFlights = nbReportedFlights < 0 ? 0 : nbReportedFlights
                if (nbReportedFlights <= 0) {
                    if (Utils.isNotExists(noOverloadPeriod)) {
                        noOverloadPeriod = countingPeriod;
                    }
                    if (TimeUtils.diffInMinutes(countingPeriod.to, noOverloadPeriod.from) >= 60) {
                        // We have to check for the full hourly count period, in order to know when to efficiently stop the regulation
                        regEndTime = noOverloadPeriod.to;
                    }
                } else {
                    noOverloadPeriod = null;
                }
                countingPeriod = {
                    from: countingPeriod.to,
                    to: TimeUtils.addMinutes(countingPeriod.to, COUNTING_INTERVAL),
                };
            }
        }

        return {
            from: regStartTime,
            to: regEndTime,
        };
    }

    private static getFlightsInPeriod(flights: Array<FlightDto>, period: TimePeriod): Array<FlightDto> {
        return flights.filter(flight => TimePeriodUtils.contains(period, flight.timeAtReferenceLocationEntry?.time));
    }

    /**
     * This function :
     * - merges initial constraints and supplementary constraints together in case of ENTRY regulation
     * - returns occupancy constraints in case of OCCUPANCY regulation
     */
    static getRegulationPeriods(regulation: RegulationOrMcdmOnlyDto): RegulationPeriods {
        if (!regulation) return;

        const initialConstraints = regulation.initialConstraints?.filter(
            c => c.timePeriod && TimePeriodUtils.isValid(c.timePeriod),
        );
        const occupancyConstraints = regulation.occupancyConstraints?.filter(
            c => c.timePeriod && TimePeriodUtils.isValid(c.timePeriod),
        );
        if (Utils.isEmpty(initialConstraints) && Utils.isEmpty(occupancyConstraints)) return;

        let regulationPeriods: RegulationPeriods;
        if (MeasureUtils.isOccupancyRegulation(regulation) && Utils.isNotEmpty(occupancyConstraints)) {
            regulationPeriods = {
                calculationType: CountType.OCCUPANCY,
                constraints: occupancyConstraints.map(c => ({
                    rate: MeasureUtils.getOccupancyRate(c),
                    timePeriod: c.timePeriod,
                    peakRate: c.peakCapacity || 0,
                })),
                occupancyDuration: regulation.occupancyDurationInMs,
            };
        } else if (MeasureUtils.isEntryRegulation(regulation) && Utils.isNotEmpty(initialConstraints)) {
            const constraints = initialConstraints.slice();
            if (regulation.supplementaryConstraints) {
                regulation.supplementaryConstraints.forEach(supConstraint => {
                    let idx = 0;
                    while (idx < constraints.length) {
                        const regulationPeriod = constraints[idx];
                        if (
                            regulationPeriod?.timePeriod &&
                            TimePeriodUtils.isValid(regulationPeriod?.timePeriod) &&
                            supConstraint?.timePeriod &&
                            TimePeriodUtils.isValid(supConstraint?.timePeriod) &&
                            TimePeriodUtils.intersects(regulationPeriod.timePeriod, supConstraint.timePeriod)
                        ) {
                            const intersection = TimePeriodUtils.intersection(
                                regulationPeriod.timePeriod,
                                supConstraint.timePeriod,
                            );
                            const updatedPeriods: Array<RegInitialConstraint> = [
                                {
                                    timePeriod: { from: regulationPeriod.timePeriod.from, to: intersection.from },
                                    normalRate: MeasureUtils.getRate(regulationPeriod),
                                } as RegInitialConstraint,
                                {
                                    timePeriod: { from: intersection.from, to: intersection.to },
                                    normalRate:
                                        MeasureUtils.getRate(regulationPeriod) + (supConstraint.supplementaryRate || 0),
                                } as RegInitialConstraint,
                                {
                                    timePeriod: { from: intersection.to, to: regulationPeriod.timePeriod.to },
                                    normalRate: MeasureUtils.getRate(regulationPeriod),
                                } as RegInitialConstraint,
                            ].filter(
                                regulationPeriod =>
                                    regulationPeriod.timePeriod.to.getTime() >
                                    regulationPeriod.timePeriod.from.getTime(),
                            ); // Only keep valid periods (!= logic than TimePeriodUtils.isValid)
                            constraints.splice(constraints.indexOf(regulationPeriod), 1, ...updatedPeriods);
                            idx += updatedPeriods.length;
                        } else {
                            idx++;
                        }
                    }
                });
            }
            regulationPeriods = {
                calculationType: CountType.ENTRY,
                constraints: constraints.map(c => ({
                    rate: MeasureUtils.getRate(c),
                    timePeriod: c.timePeriod,
                })),
            };
        }
        return regulationPeriods;
    }

    static getHighestHotspot(hotspots: HotspotDto[]) {
        let reply: HotspotDto;
        for (const hotspot of hotspots) {
            if (hotspot.status !== HotspotStatus.CANCELLED) {
                switch (hotspot.kind) {
                    case HotspotKind.PROBLEM:
                        return hotspot;
                    case HotspotKind.PROTECTION:
                        if (!reply || reply.kind === HotspotKind.LOCATION_OF_INTEREST) {
                            reply = hotspot;
                        }
                        break;
                    case HotspotKind.LOCATION_OF_INTEREST:
                        if (!reply) {
                            reply = hotspot;
                        }
                        break;
                }
            }
            return reply;
        }
    }

    /**
     * Default pending rate is 5% of total rate if rate >= 20/hour
     */
    static getDefaultPendingRate(rate: number) {
        return rate >= 20 ? Math.round(rate * 0.05) : 0;
    }

    static toMeasureTypeString(measure: MeasureDto): string {
        if (MeasureUtils.isRegulation(measure)) {
            return 'REGULATION';
        } else if (MeasureUtils.isRerouting(measure)) {
            return 'REROUTING';
        } else if (MeasureUtils.isMcdmOnly(measure)) {
            return 'MCDM ONLY';
        } else if (MeasureUtils.isRegulationProposal(measure)) {
            return 'REGULATION';
        }
        return '';
    }

    static toMeasureSubTypeString(measureSubType: MeasureSubType): string {
        switch (measureSubType) {
            case MeasureSubType.GROUND_DELAY:
                return 'Ground Delay';
            case MeasureSubType.AIRBORNE_HORIZONTAL_REROUTING:
                return 'ATC Horizontal Rerouting';
            case MeasureSubType.AIRBORNE_LEVEL_CAP:
                return 'ATC Level Cap';
            case MeasureSubType.GROUND_HORIZONTAL_REROUTING:
                return 'Ground Horizontal Rerouting';
            case MeasureSubType.GROUND_LEVEL_CAP:
                return 'GroundLevel Cap';
            case MeasureSubType.MILES_MINUTES_IN_TRAIL:
                return 'Miles In Trail';
            case MeasureSubType.MINIMUM_DEPARTURE_INTERVAL:
                return 'Min Departure Interval';
            case MeasureSubType.OTHER_KIND_OF_STAM_MEASURE:
                return 'Other';
            case MeasureSubType.TAKE_OFF_NOT_AFTER:
                return 'Take Off Not After';
            case MeasureSubType.TAKE_OFF_NOT_BEFORE:
                return 'Take Off Not Before';
            case MeasureSubType.TERMINAL_PROCEDURE_CHANGE:
                return 'Change of Terminal Procedure';
        }
    }

    static toRegulationReasonString(measureReason: RegulationReasonType): string {
        switch (measureReason) {
            case RegulationReasonType.ACCIDENT_INCIDENT:
                return 'Accident/Incident';
            case RegulationReasonType.AERODROME_CAPACITY:
                return 'Aerodrome Capacity';
            case RegulationReasonType.AERODROME_SERVICES:
                return 'Aerodrome Services';
            case RegulationReasonType.AIRSPACE_MANAGEMENT:
                return 'Airspace Management';
            case RegulationReasonType.ATC_CAPACITY:
                return 'ATC Capacity';
            case RegulationReasonType.ATC_EQUIPMENT:
                return 'ATC Equipment';
            case RegulationReasonType.ATC_INDUSTRIAL_ACTION:
                return 'ATC Ind Action';
            case RegulationReasonType.ATC_ROUTINGS:
                return 'ATC Routings';
            case RegulationReasonType.ATC_STAFFING:
                return 'ATC Staffing';
            case RegulationReasonType.ENVIRONMENTAL_ISSUES:
                return 'Environmental Issues';
            case RegulationReasonType.NON_ATC_INDUSTRIAL_ACTION:
                return 'Ind Action non-ATC';
            case RegulationReasonType.OTHERS:
                return 'Others';
            case RegulationReasonType.SPECIAL_EVENT:
                return 'Special Event';
            case RegulationReasonType.WEATHER:
                return 'Weather';
        }
    }

    static toDisplayMeasureTypeString(displayMeasureType: DisplayMeasureType) {
        switch (displayMeasureType) {
            case DisplayMeasureType.NETWORK_MEASURE:
                return 'Network Measure';
            case DisplayMeasureType.FMP_MEASURE:
                return 'FMP Measure';
            case DisplayMeasureType.NETWORK_CHERRY_PICK_MEASURE:
                return 'Network Cherry Pick Measure';
            case DisplayMeasureType.FMP_CHERRY_PICK_MEASURE:
                return 'FMP Cherry Pick Measure';
        }
    }

    static toMCDMKindString(mcdmKind: MCDMKind): string {
        switch (mcdmKind) {
            case MCDMKind.NO:
                return 'No';
            case MCDMKind.YES:
                return 'Yes';
            case MCDMKind.MCDM_ONLY:
                return 'MCDM Only';
        }
    }

    static getMonitoredMeasureCreationClassname(monitoredMeasure: MonitoredMeasure): string {
        if (monitoredMeasure.measure.lastUpdate.userUpdateType !== LifeCycleEventType.CREATION) return '';

        switch (TimeUtils.diffInMinutes(TimeUtils.NOW(), monitoredMeasure.measure.lastUpdate.eventTime)) {
            case 0:
                return 'new-0mn';
            case 1:
                return 'new-1mn';
            case 2:
                return 'new-2mn';
        }
        return '';
    }

    static toRegulationNormalRateString(regulation: RegulationDto): string {
        // Find sub-period with smallest rate
        if (MeasureUtils.isEntryRegulation(regulation)) {
            const smallest: RegInitialConstraint = regulation.initialConstraints.reduce((acc, curr) =>
                MeasureUtils.getRate(acc) < MeasureUtils.getRate(curr) ? acc : curr,
            );
            const hasOthers = regulation.initialConstraints.length > 1 ? '+' : '  ';
            return `${Utils.leftPadZero(smallest.normalRate, 2)}${hasOthers}`;
        } else {
            const smallest = regulation.occupancyConstraints.reduce((acc, curr) =>
                MeasureUtils.getOccupancyRate(acc) < MeasureUtils.getOccupancyRate(curr) ? acc : curr,
            );
            const hasOthers = regulation.occupancyConstraints.length > 1 ? '+' : '  ';
            return `${Utils.leftPadZero(smallest.peakCapacity, 2)}${hasOthers}`;
        }
    }

    static toRegulationPendingRateString(regulation: RegulationDto): string {
        // Find sub-period with smallest rate
        if (MeasureUtils.isEntryRegulation(regulation)) {
            const smallest: RegInitialConstraint = regulation.initialConstraints.reduce(
                (acc: RegInitialConstraint, curr: RegInitialConstraint) =>
                    MeasureUtils.getRate(acc) < MeasureUtils.getRate(curr) ? acc : curr,
            );
            return `${Utils.leftPadZero(smallest.pendingRate, 2)}`;
        } else {
            const smallest = regulation.occupancyConstraints.reduce((acc, curr) =>
                MeasureUtils.getOccupancyRate(acc) < MeasureUtils.getOccupancyRate(curr) ? acc : curr,
            );
            return `${Utils.leftPadZero(MeasureUtils.getOccupancyRate(smallest), 2)}`;
        }
    }

    // Find sub-period with smallest rate
    static toRegulationRateString(regProposal: RegulationOrMcdmOnlyDto): string {
        if (MeasureUtils.isEntryRegulation(regProposal)) {
            const smallest: RegInitialConstraint = regProposal.initialConstraints.reduce(
                (acc: RegInitialConstraint, curr: RegInitialConstraint) =>
                    MeasureUtils.getRate(acc) < MeasureUtils.getRate(curr) ? acc : curr,
            );
            const hasOthers = regProposal.initialConstraints.length > 1 ? '+' : '  ';
            return `${Utils.leftPadZero(MeasureUtils.getRate(smallest), 2)}${hasOthers}`;
        } else {
            const smallest: RegulationOccupancyConstraintDto = regProposal.occupancyConstraints.reduce((acc, curr) =>
                MeasureUtils.getOccupancyRate(acc) < MeasureUtils.getOccupancyRate(curr) ? acc : curr,
            );
            const hasOthers = regProposal.occupancyConstraints.length > 1 ? '+' : ' ';
            return `${Utils.leftPadZero(MeasureUtils.getOccupancyRate(smallest), 2)}${hasOthers}`;
        }
    }

    static hourlyEntryCapacityToRegInitialConstraints(
        hourlyEntryCapacity: Array<CapacityValue>,
        regPeriod: TimePeriod,
    ): Array<RegInitialConstraint> {
        if (!hourlyEntryCapacity) return [];

        // Regulation rate is adapted according to declared capacity
        return hourlyEntryCapacity
            .filter(capacityValue => TimePeriodUtils.intersects(capacityValue.timePeriod, regPeriod))
            .map(capacityValue => {
                const pendingRate = MeasureUtils.getDefaultPendingRate(capacityValue.hourlyCapacity);
                return {
                    normalRate: capacityValue.hourlyCapacity - pendingRate,
                    pendingRate: pendingRate,
                    timePeriod: {
                        from: TimeUtils.max(capacityValue.timePeriod.from, regPeriod.from),
                        to: TimeUtils.min(capacityValue.timePeriod.to, regPeriod.to),
                    },
                } as RegInitialConstraint;
            })
            .sort((c1, c2) => TimePeriodUtils.COMPARE_FUNCTION(c1.timePeriod, c2.timePeriod));
    }

    static otmvsToRegOccupancyConstraints(
        otmvs: Array<Otmv>,
        regPeriod: TimePeriod,
    ): RegulationOccupancyConstraintDto[] {
        if (!otmvs) return [];

        // Regulation rate is adapted according to declared capacity
        return otmvs
            .filter(otmv => TimePeriodUtils.intersects(otmv.timePeriod, regPeriod))
            .map(
                otmv =>
                    ({
                        peakCapacity: otmv.peakValue,
                        occupancyRate: otmv.sustainedValue,
                        pendingCapacityPercentage: 0,
                        timePeriod: {
                            from: TimeUtils.max(otmv.timePeriod.from, regPeriod.from),
                            to: TimeUtils.min(otmv.timePeriod.to, regPeriod.to),
                        },
                    }) as RegulationOccupancyConstraintDto,
            )
            .sort((c1, c2) => TimePeriodUtils.COMPARE_FUNCTION(c1.timePeriod, c2.timePeriod));
    }

    static isMcdmStateActive(state: McdmState) {
        switch (state) {
            case McdmState.DRAFT:
            case McdmState.PROPOSED:
            case McdmState.COORDINATED:
                return true;
            case McdmState.IMPLEMENTING:
            case McdmState.IMPLEMENTED:
            case McdmState.FINISHED:
            case McdmState.ABANDONED:
            case McdmState.INTERRUPTED:
                return false;
        }
    }

    static toMeasureReasonString(measure: MeasureDto): string {
        if (MeasureUtils.isRegulationOrMcdmOnly(measure)) return MeasureUtils.toRegulationReasonString(measure.reason);
        if (MeasureUtils.isRerouting(measure)) return MeasureUtils.toReroutingPurposeString(measure.reroutingPurpose);
    }

    static toReroutingPurposeString(reroutingPurpose: ReroutingPurpose): string {
        switch (reroutingPurpose) {
            case ReroutingPurpose.AOLO_REROUTING:
                return 'AOLO Rerouting';
            case ReroutingPurpose.ATC_ROUTING:
                return 'ATC Rerouting';
            case ReroutingPurpose.ATFCM:
                return 'ATFCM';
            case ReroutingPurpose.CDR_OPPORTUNITY:
                return 'CDR Opportunity';
            case ReroutingPurpose.FLIGHT_EFFICIENCY:
                return 'Flight Efficiency';
            case ReroutingPurpose.STAM:
                return 'STAM';
        }
    }

    static toReroutingConstraintsString(rerouting: ReroutingDto): string[] {
        return rerouting.sourcesAndConstraints.reroutingConstraintSets.flatMap(constraint => {
            return constraint.constraints.map((constraint: ReroutingConstraintDto) => {
                if (MeasureUtils.isAvoidViaAirspaceConstraint(constraint)) {
                    return `${constraint.type} AS:${constraint.location} ${constraint.avoidKind}`;
                } else if (MeasureUtils.isAvoidViaPointConstraint(constraint)) {
                    return `${constraint.type} P:${constraint.location?.id}`;
                } else if (MeasureUtils.isAvoidViaRegulationConstraint(constraint)) {
                    return `${constraint.type} R:${constraint.regulationId} ${constraint.avoidKind}`;
                } else if (MeasureUtils.isAvoidViaHotspotConstraint(constraint)) {
                    return `${constraint.type} H:${constraint.hotspotId.tvId} ${constraint.avoidKind}`;
                } else if (MeasureUtils.isLevelAndSpeedConstraint(constraint)) {
                    return `${constraint.fromPoint?.id}->${constraint.untilPoint?.id} S:${constraint.airSpeed?.speed}${constraint.airSpeed?.unit} FL:${constraint.flightLevel?.value}${constraint.flightLevel?.unit}`;
                } else if (MeasureUtils.isDeltaLevelConstraint(constraint)) {
                    return `${constraint.location?.id} DeltaFL:${constraint.deltaFlightLevel}`;
                }
            });
        });
    }

    /**
     * Returns the minimum capacity as a string (DDHHMM : CapacityValue).
     * If there are multiple capacity periods, adds a '+'
     * @param capacities
     * @param applicability
     */
    static toHourlyCapacityString = (capacities: CapacityValue[], applicability?: TimePeriod): string => {
        const minCapacity = capacities
            ?.filter(capacity => TimePeriodUtils.intersects(capacity.timePeriod, applicability))
            .reduce((acc, capacity) => (capacity.hourlyCapacity < acc.hourlyCapacity ? capacity : acc), {
                hourlyCapacity: Number.MAX_VALUE,
            });
        return `${Utils.leftPadZero(minCapacity?.hourlyCapacity, 2)}${capacities?.length > 1 ? '+' : ''}`;
    };

    /**
     * Returns true if the MCDM measure topic state is "UNKNOWN",
     * meaning that the measure has not been ACKNOWLEDGED by NMOC
     * @param mcdmMeasure
     */
    static isNewMcdmMeasure = (mcdmMeasure: McdmMeasure): boolean => {
        return MeasureUtils.getNMOCApprovalState(mcdmMeasure.mcdmMeasureTopic) === McdmApprovalState.UNKNOWN;
    };

    /**
     * Returns the "NMOC" measure approval state
     * S49 relies on this approval state instead of the traditional MCDM State,
     * since the MCDM state can't be updated B2B, whereas the mcdm approval state can be updated by B2B
     * @param topic
     */
    static getNMOCApprovalState = (topic: McdmMeasureTopic): McdmApprovalState => {
        return MeasureUtils.getUserRoleAndApprovalState(topic, MeasureUtils.NMOC_MCDM_USER_ID)?.approvalState;
    };

    /**
     * Update the MCDM Approval state to "ACK", also set the userId in the "remark' field,
     * this will be displayed in the MCDMMeasurePanel
     * @param mcdmMeasures
     */
    static acknowledgeMcdmMeasures = (mcdmMeasures: McdmMeasure[]): Promise<McdmMeasure[]> => {
        return Promise.all(
            mcdmMeasures.map(mcdmMeasure => {
                return ServiceFactory.stamCoreService().updateMcdmTopic({
                    dataset: AppContext.getDataset(),
                    day: AppContext.getMonitoredDay(),
                    topic: {
                        clazz: MCDM_MEASURE_TOPIC_CLAZZ_VALUE,
                        dataId: mcdmMeasure.mcdmMeasureTopic.dataId,
                        topicId: mcdmMeasure.mcdmMeasureTopic.topicId,
                        remark: 'USER(' + AppContext.configData.claimedUserId + ')',
                        userRoleAndApprovalStates: [
                            {
                                userId: MeasureUtils.NMOC_MCDM_USER_ID,
                                approvalState: McdmApprovalState.ACKNOWLEDGED,
                            },
                        ],
                    } as McdmMeasureTopic,
                });
            }),
        )
            .then(reply => {
                return reply.flatMap(reply => {
                    if (reply.error) {
                        console.log(reply.error);
                        notification.error({ message: reply.error.message, description: reply.error.details });
                        return [];
                    } else {
                        // Update the data ID following the update of the topic, to avoid CONFLICTING_UPDATE error
                        return mcdmMeasures.map(m =>
                            m.mcdmMeasureTopic.topicId === reply.data.topicId
                                ? {
                                      ...m,
                                      mcdmMeasureTopic: reply.data,
                                      measure: { ...m.measure, dataId: reply.data.dataId },
                                  }
                                : m,
                        );
                    }
                });
            })
            .catch(err => {
                console.log(err);
                notification.error({
                    message: 'Error acknowledging measure(s), see console',
                });
                return [];
            });
    };

    static isEntryRegulation = (regulation: RegulationOrMcdmOnlyDto): boolean => {
        return Utils.isNotExists(regulation?.calculationType) || regulation?.calculationType === CountType.ENTRY;
    };

    static isOccupancyRegulation = (regulation: RegulationOrMcdmOnlyDto): boolean => {
        return regulation?.calculationType === CountType.OCCUPANCY;
    };

    static getFilteredMeasures(
        measures: Array<MonitoredMeasure>,
        textFilter: string,
        settings: MeasuresSettings,
        monitoredPeriod: TimePeriod,
    ) {
        if (!measures) return [];

        let filteredMeasures = measures;
        if (textFilter) {
            const upperCasetextFilter = Utils.toUpperCase(textFilter).split(' ');
            filteredMeasures = filteredMeasures.filter(({ measure }) => {
                const measureId = Utils.toUpperCase(measure.measureId.id);
                const tvId = Utils.toUpperCase(MeasureUtils.getTvLocation(measure).id);
                const fmp = Utils.toUpperCase(MeasureUtils.isRegulation(measure) ? measure.delayTvSetId : '');
                //if the query text has a * uses the simpleWildcardEquals, otherwise checks if a tv or measure contains the given query text
                const matchingTextFilters = upperCasetextFilter.filter(textFilterEl => {
                    const re = Utils.wildcardToRegex(textFilterEl);
                    return re.test(tvId) || re.test(measureId) || re.test(fmp);
                });
                return matchingTextFilters.length > 0;
            });
        }

        if (settings) {
            filteredMeasures = filteredMeasures.filter(monitoredMeasure => {
                const regulationState = MeasureUtils.getRegulationState(monitoredMeasure.measure);
                return (
                    (settings.activeOnly
                        ? regulationState === RegulationState.APPLIED || regulationState === RegulationState.APPLYING
                        : true) &&
                    (settings.monitoredPeriodOnly
                        ? TimePeriodUtils.intersects(monitoredPeriod, monitoredMeasure.measure.applicability)
                        : true) &&
                    settings.reasons.includes((monitoredMeasure.measure as RegulationOrMcdmOnlyDto).reason)
                );
            });
        }

        return filteredMeasures;
    }

    static getRegulationId = (tvId: string): string => {
        return tvId.concat('Z').substring(0, 5).concat(Utils.leftPadZero(AppContext.getMonitoredDay().getDate(), 2));
    };

    static getProposalMeasureIds = memoizeOne((monitoredMcdmMeasures: Array<MonitoredMcdmMeasure>) => {
        // TODO consider "proposalFeedback" state when able to change it
        return monitoredMcdmMeasures
            ?.filter(proposal => proposal.mcdmMeasureTopic.state === McdmState.PROPOSED)
            .map(m => m.measure.measureId.id);
    });
}
